import { Container, Grid } from '@material-ui/core';
import React from 'react';
import { useParams } from 'react-router-dom';
import VendorPriceItemEditForm from './components/VendorPriceItemEditForm';
import ClientEditSidebar, {
    ACTIVE_CLIENT_SIDEBAR_TAB_NAMES
} from '../clientedit/ClientEditSidebar';

const VendorPriceItemEditPage = () => {
    const { clientId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.vendorpriceitems} />
                <Grid className="pageContent">
                    <VendorPriceItemEditForm clientId={clientId} />
                </Grid>
            </Grid>
        </Container>
    );
};

export default VendorPriceItemEditPage;
